import { FETCH_CATEGORY_GAME_COUNT, FETCH_CATEGORY_GAME_COUNT_SUCCESS } from './actionTypes';

export const fetchCategoryGameCount = () => {
    return {
        type: FETCH_CATEGORY_GAME_COUNT,
        payload: {},
    }
};

export const fetchCategoryGameCountSuccess = (response) => {
    return {
        type: FETCH_CATEGORY_GAME_COUNT_SUCCESS,
        payload: response
    }
};
